import { Injectable } from '@angular/core';
import { HttpService } from './http-service';
import { Authenticate } from './authenticate';
import { Observable } from 'rxjs';
import { UserProfile } from './UserProfile';

@Injectable({
  providedIn: 'root'
})
export class VidaAdapterLoginService {

  private apiURL = API_GATEWAY.SERVER;
  private userProfile: any;
  private userInfo: any;
  constructor(
    private httpClient: HttpService
  ) { }

  public authenticate(authenticate: Authenticate): Observable<any> {
    return new Observable(obs => {
      this.httpClient.getByText(API_GATEWAY.USER_INFO_VIDA_URL, authenticate.username).subscribe((responses) => {
        let responseValue: any = responses;
        if (responseValue != null && Boolean(responseValue.status)) {
          this.userInfo = responseValue;
          this.httpClient.post(API_GATEWAY.LOGGED_USER_VIDA_URL, authenticate).subscribe((response) => {
            let responseObject: any = response;
            if (responseObject != null && responseObject.status == "Active") {
              this.setUserInformation(responseObject);
              obs.next(response);
              obs.complete();
            } else {
              obs.next(response);
              obs.complete();
            }
          }, error => {
            obs.next(error);
            obs.complete();
          });
        } else {
          obs.next(responseValue);
          obs.complete();
        }
      }, error => {
        obs.next(obs);
        obs.complete();
      });
    });
  }

  setUserInformation(responseObject) {
    this.setAccessToken(responseObject.token);
    let userProfile = new UserProfile();
    userProfile.userId = this.userInfo.loggedUserId;
    userProfile.memberId = Number(responseObject.userId);
    userProfile.memberName = this.userInfo.userName;
    userProfile.memberPosition = this.userInfo.userPosition;
    userProfile.memberPositionCode = this.userInfo.userPositionCode;
    localStorage.setItem('LOGGED_USER_VIDA_PROFILE_TEST', JSON.stringify(userProfile));
  }

  ProfileDisplay() {
    var user = JSON.parse(localStorage.getItem('LOGGED_USER_VIDA_PROFILE_TEST'));
    return user;
  }

  public logOut() {
    localStorage.removeItem(API_GATEWAY.ACCESS_TOKEN_KEY);
    localStorage.removeItem(API_GATEWAY.REFRESH_TOKEN_KEY);
    localStorage.removeItem('LOGGED_USER_VIDA_PROFILE_TEST');
    localStorage.removeItem('HHC');
    window.location.href = API_GATEWAY.LOGOUT_USER_URL;
  }

  public isAuthorized() {
    var isAuthorized = !!localStorage.getItem(API_GATEWAY.ACCESS_TOKEN_KEY);
    let userProfile = new UserProfile();
    userProfile.status = isAuthorized;
    if (this.userProfile != null)
      userProfile = this.userProfile;
    return new Observable(function (obs) {
      obs.next(userProfile);
      obs.complete();
    });
  }

  public setAccessToken(token) {
    localStorage.setItem(API_GATEWAY.ACCESS_TOKEN_KEY, token);
  };

  public getAccessToken() {
    return localStorage.getItem(API_GATEWAY.ACCESS_TOKEN_KEY);
  };

  public setLoggedUser(user) {
    localStorage.setItem(API_GATEWAY.LOGGED_USER_VIDA_PROFILE, user);
    return new Observable(obs => {
      this.userProfile = user;
      obs.next(this.userProfile);
      obs.complete();
    });
  }

  public isLoggednIn() {
    return this.getAccessToken() !== null;
  }
}

export const API_GATEWAY = {
  SERVER: "https://localhost:44300/api",
  ACCESS_TOKEN_KEY: "access_token",
  REFRESH_TOKEN_KEY: "refresh_token",
  REFRESH_TOKEN_URL: "",
  LOGGED_USER_URL: "https://localhost:44300/api/User/Authenticate",
  LOGOUT_USER_URL: "http://localhost:4200/login",
  LOGGED_USER_VIDA_URL: "http://10.20.10.119:1013/api/account",
  USER_INFO_VIDA_URL: "https://localhost:44300/api/Home/getUserInformation",
  LOGGED_USER_VIDA_PROFILE: "",
  LOGGED_USER_PERMISSIONS: "user_permission",
  VIDAPLUS_LOGGED_USER_URL: "http://dev.k8s.local",
  VIDAPLUS_BASE_SECURITY_TOKEN: "/service-base-security-token/auth?response_type=code&client_id=web",
  VIDAPLUS_ACEESS_TOKEN: "/service-base-security-token/token",
  VIDAPLUS_LOGGEDIN_TOKEN: "/service-base-security-token/token/logged-in-user",
  VIDA_MIDDLE_LAYER: "https://localhost:44361",//http://10.20.10.119:1013
};

